import BrevoEventForm from "./BrevoEventForm";

const TriggerBrevoEventsLanding = () => {
  return (
    <div className="flex flex-col gap-10 p-6">
      <div>
        <h1 className="mb-1 text-2xl font-bold">Brevo Events</h1>
      </div>
      <BrevoEventForm />
    </div>
  );
};

export default TriggerBrevoEventsLanding;
